var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copopover"},[_c('div',{staticClass:"buttonWrapper d-flex",attrs:{"id":_vm.id}},[_vm._t("default")],2),_c('div',{ref:"content",staticClass:"contentWrapper"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }